/**
 * Перенос `enum VerifyAdminType` из
 * `lib/src/presentation/pages/verify_admin/verify_admin_page.dart`.
 *
 * В Dart перечисление лежало в файле самой страницы, и роутер тянул её
 * целиком. Здесь оно вынесено отдельно: на него ссылаются и роутер, и
 * экран адреса сервера, а страница подключается только там, где рисуется.
 */

export const VerifyAdminType = {
  changePerson: 'changePerson',
  exitApp: 'exitApp',

  /** Журнал для разработчика — вход 5 тапами по версии на экране языка. */
  diagnostics: 'diagnostics',

  /**
   * Добавка к Dart: смена сервера или планшета — кнопка настроек на экране
   * языка.
   *
   * В оригинале настройки вели к смене аватара, и это было осмысленно:
   * список аватаров лежал за PIN. Здесь он — вход в киоск и открыт всем
   * (см. README, «Что сделано иначе»), поэтому дверь за PIN нужна уже не
   * для аватара, а для адреса планшета.
   *
   * В переключателе внизу PIN-экрана не показывается — как и
   * [diagnostics]: это отдельный вход, а не режим, между которыми там
   * переключаются.
   */
  changeServer: 'changeServer',
} as const;

export type VerifyAdminType = (typeof VerifyAdminType)[keyof typeof VerifyAdminType];

/** Аналог `VerifyAdminType.values`: порядок объявления сохранён. */
export const VERIFY_ADMIN_TYPE_VALUES: readonly VerifyAdminType[] =
  Object.values(VerifyAdminType);

/**
 * Значение из адреса (`:type`).
 *
 * go_router разбирал параметр сам и на неизвестном значении не собирал
 * маршрут вовсе. В вебе адрес можно набрать руками, поэтому чужое значение
 * трактуется как `changePerson` — то же умолчание, что у `BaseUrlRoute`:
 * самый безобидный режим (смена аватара), а не выход из приложения.
 */
export function verifyAdminTypeFromParam(value: string | undefined): VerifyAdminType {
  const found = VERIFY_ADMIN_TYPE_VALUES.find((type) => type === value);
  return found ?? VerifyAdminType.changePerson;
}
